<template>
  <deck-form />
</template>

<script>
import DeckForm from '@/components/forms/DeckForm'
export default {
  components: {
    DeckForm
  }
}
</script>
